// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MdYv","content":"styles_content__3x2Xz"};